// The toast the References and Rules managers raise after a save — one copy
// for both screens and the Oversight manager (code review G-10).
import { useCallback } from 'react'
import { Toast, ToastTitle, useToastController } from '@fluentui/react-components'
import { TOASTER_ID } from '../lib/constants'

export function useToast() {
  const { dispatchToast } = useToastController(TOASTER_ID)
  return useCallback(
    (title: string, intent: 'success' | 'error' = 'success') =>
      dispatchToast(
        <Toast>
          <ToastTitle>{title}</ToastTitle>
        </Toast>,
        { intent },
      ),
    [dispatchToast],
  )
}
